// import {MbWeb} from 'react-icons/md'
// import {FaHandHoldingHeart} from 'react-icons/fa'
// import {VscCode} from 'react-icons/vsc'
import { UilReact, UilCss3Simple, UilWindow  } from '@iconscout/react-unicons'


export default [
    {
        title:'Web Design',
        icon:<UilWindow  className='w-full h-full'/>,
        descreption:'Clean, modern, and user-centric – these are the principles that underpin my design philosophy. I believe in the power of simplicity to convey complex messages effectively. Through the use of thoughtful typography, harmonious color palettes, and engaging visuals, I aim to create designs that leave a lasting impression.',
    },

    {
        title:'React Js',
        icon:<UilReact className='w-full h-full'/>,
        descreption:'In this section, you all find a curated selection of projects that exemplify my proficiency in React.js. Each project reflects my dedication to creating user-friendly interfaces and leveraging the full potential of this remarkable library.',
    },

    {
        title:'Tailwind CSS',
        icon:<UilCss3Simple className='w-full h-full'/>,
        descreption:'Tailwind CSS has revolutionized the way I approach web design and development. Its unique utility-first approach allows me to create custom and responsive designs without the need for writing custom CSS. The extensive set of pre-built utility classes provides flexibility and speed, empowering me to iterate quickly and focus on crafting remarkable user experiences.',
    }
]